module.exports = __webpack_public_path__ + "static/image/history/pc/202204@3x.ver2_0_2.jpg?e630bf78";